module.exports = __webpack_public_path__ + "static/media/Home-BG.44f14ef1.png";